<template>
    <div>
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>

        <div class="alert alert-success" v-if="markedComplete">
            The door check has been marked as complete successfully.
        </div>

        <div class="alert alert-success" v-if="isDeleted">
            The door check has been deleted successfully.
        </div>
        <div class="incomplete-survey-container" v-if="!markedComplete && !isDeleted">

            <div class="mb-5 entity-row-1">

                <div class="row border pt-3 pb-3">
                    <div class="col-md-8">
                        <p><strong class="search-title" data-container="entity-row-1">
                            <router-link :to="{ name: 'door-check-view', params: {id: doorCheck.site_door_check_id} }">
                            {{ doorCheck.document_id }} | {{ doorCheck.document_title }}
                            </router-link>
                        </strong><br>
                        <small>version: <span v-if="doorCheck.report_version">{{ doorCheck.report_version }}</span><span v-else>NO VERSION</span></small>
                            <!--<small>Added by {{ doorCheck.user.user_name }} on {{ doorCheck.created | formatDate }}, last modified {{ doorCheck.modified | formatDate }}</small>-->
                        </p>
                    </div>
                    <div class="col-md-4">
                        <router-link :to="{ name: 'door-check-add-door', params: {id: doorCheck.site_door_check_id} }" class="btn btn-square btn-lg btn-outline-primary w-100 pt-2 pb-2">
                        Add Door </router-link>
                    </div>
                </div>

                <div class="row border border-top-0 border-bottom-0 pb-3">
                    <div class="col-md-12 mt-3">

                        <div class="table-responsive">
                        <table class="table table-condensed table-bordered">
                            <door-check-door-line
                                    v-for="door_check_door in filteredDoorCheckDoors"
                                    v-bind:key="door_check_door.id"
                                    v-bind:door_check_door="door_check_door"
                            ></door-check-door-line>
                        </table>
                        </div>
                    </div>
                </div>

                <div class="row border-top pt-4 pb-4 bg-grey">

                    <div class="col-md-3 mb-2">
                            <router-link :to="{ name: 'door-check-edit', params: {id: doorCheck.site_door_check_id} }" class="btn btn-md btn-square btn-outline-secondary w-100"
                               style="margin: 0 5px;">
                                Edit </router-link>
                    </div>
                    <div class="col-md-3 mb-2">
                            <a class="btn btn-md btn-square btn-outline-dark w-100" v-if="navigatorOnline && doorCheck.door_check_id"
                               v-on:click="exportReport"
                               ref="exportReportButton"
                               target="_blank"
                               v-bind:data-report-id="doorCheck.door_check_id"
                               style="margin: 0 5px;">
                                Export </a>

                            <a class="btn btn-md btn-square btn-outline-dark w-100 btn-disabled" v-else
                               style="margin: 0 5px;">
                                <img class="img-fluid" src="/img/offline.png" style="width: 20px; margin-right: 10px;" v-if="!navigatorOnline"> Sync required </a>
                    </div>
                    <div class="col-md-3 mb-2">
                        <button
                                v-on:click="markComplete"
                                ref="markCompleteButton"
                                class="btn btn-md btn-square btn-outline-success w-100"
                                v-bind:data-report-id="doorCheck.site_door_check_id"
                                style="margin: 0 5px;"
                        >Mark Complete</button>

                    </div>
                    <div class="col-md-3 mb-2" v-if="dbName !== 'pacific' && dbName !== 'dev'">
                        <button
                                v-on:click="deleteDoorCheck"
                                ref="deleteButton"
                                class="btn btn-md btn-square btn-outline-danger w-100"
                                v-bind:data-report-id="doorCheck.site_door_check_id"
                                style="margin: 0 5px;"
                                >
                            Delete
                        </button>

                    </div>
                </div>

                <div class="row border-top pt-4 pb-4 bg-grey">
                    <div class="col-md-12">
                        <span v-if="doorCheck.pdf_link === null || doorCheck.pdf_link === undefined">
                            <span class="far fa-file-pdf mr-3"></span> No PDF link available. Please export a PDF then do a sync to see the latest link here.
                        </span>
                        <span v-else>
                            <span class="far fa-file-pdf mr-3"></span> <a target="_blank" v-bind:href="returnPdfUrl(doorCheck.pdf_link)">{{ returnPdfUrl(doorCheck.pdf_link) }}</a><br><small>
                            After you export a report, you will need to do a sync to see the latest link here.
                            </small>
                        </span>
                    </div>
                </div>


            </div>

        </div>
    </div>
</template>

<script>
    import DoorCheckDoorLine from '@/components/DoorCheckDoorLine.vue';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css'; 

    export default {
        components: {
            DoorCheckDoorLine,
            Loading
            
        },
        props: ['doorCheck', 'title', 'doorCheckDoors'],
        data() {
            return {
                isLoading: false,
                markedComplete: false,
                isDeleted: false,
                doorCheckToDelete: null,
                doorCheckToComplete: null,
            }
        },
        computed: {
            filteredDoorCheckDoors() {
                var correctDoorCheckDoors = [];
                var vm = this;
                this.doorCheckDoors.forEach(function(entry) {
                    if (entry.site_door_check_id === vm.doorCheck.site_door_check_id &&
                        (entry.is_deleted === false || entry.is_deleted === undefined)
                    ) {
                        correctDoorCheckDoors.push(entry);
                    }
                });
                return correctDoorCheckDoors;
            },
            navigatorOnline() {
                return navigator.onLine;
            }
        },
        methods: {
            returnPdfUrl(pdfUrl) {
              return this.cmsUrl.slice(0, -1) + pdfUrl;
            },
            markComplete() {
                var button = this.$refs.markCompleteButton;
                var reportId = button.dataset.reportId;

                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.")
                }

                var db;
                var dbName = this.getCmsDetails('dbname');
                var request = window.indexedDB.open(dbName, this.dbVersionNumber);

                request.onerror = function (event) {
                    console.log("error: ");
                };

                var vmt = this;
                request.onsuccess = function (event) {
                    db = request.result;

                    var vm = vmt;
                    try {
                        var doorCheckId = parseInt(reportId);
                        var objectStore = db.transaction('door_checks').objectStore('door_checks');
                        var storeRequest = objectStore.get(doorCheckId);

                        storeRequest.onsuccess = function(event) {
                            vm.doorCheckToComplete = storeRequest.result;
                            vm.doorCheckToComplete.is_complete = true;

                            vm.$swal({
                                title: 'Are you sure?',
                                text: 'Are you sure you want to mark this report as complete?',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: 'Yes',
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true,
                                buttons: {
                                    cancel: {
                                        text: 'Cancel',
                                        value: null,
                                        visible: false,
                                        className: 'btn btn-square btn-sm btn-secondary',
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Yes',
                                        value: true,
                                        visible: true,
                                        className: 'btn btn-square btn-sm btn-primary',
                                        closeModal: true
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {

                                    var putRequest = db.transaction('door_checks', 'readwrite')
                                        .objectStore('door_checks').put(vm.doorCheckToComplete);
                                    putRequest.onsuccess = function(event) {
                                        vm.markedComplete = true;
                                    };
                                    putRequest.onerror = function(event) {
                                        console.log(event);
                                    };

                                }
                            });

                        };
                        storeRequest.onerror = function(e) {
                            console.log(e)
                        }
                    } catch (e) {
                        console.log(e);
                    }

                };

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;
                };


            },
            deleteDoorCheck() {
                var button = this.$refs.deleteButton;
                var reportId = button.dataset.reportId;

                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.")
                }

                var db;
                var dbName = this.getCmsDetails('dbname');
                var request = window.indexedDB.open(dbName, this.dbVersionNumber);

                request.onerror = function (event) {
                    console.log("error: ");
                };

                var vmt = this;
                request.onsuccess = function (event) {
                    db = request.result;

                    var vm = vmt;
                    try {
                        var doorCheckId = parseInt(reportId);
                        var objectStore = db.transaction('door_checks').objectStore('door_checks');
                        var storeRequest = objectStore.get(doorCheckId);


                        storeRequest.onsuccess = function(event) {
                            vm.doorCheckToDelete = storeRequest.result;
                            vm.doorCheckToDelete.is_deleted = true;

                            vm.$swal({
                                title: 'Are you sure?',
                                text: 'Are you sure you want to delete this report?',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: 'Yes',
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true,
                                buttons: {
                                    cancel: {
                                        text: 'Cancel',
                                        value: null,
                                        visible: false,
                                        className: 'btn btn-square btn-sm btn-secondary',
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Yes',
                                        value: true,
                                        visible: true,
                                        className: 'btn btn-square btn-sm btn-primary',
                                        closeModal: true
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {

                                    var putRequest = db.transaction('door_checks', 'readwrite')
                                        .objectStore('door_checks').put(vm.doorCheckToDelete);
                                    putRequest.onsuccess = function(event) {
                                        vm.isDeleted = true;
                                    };
                                    putRequest.onerror = function(event) {
                                        console.log(event);
                                    };

                                }
                            });

                        };
                        storeRequest.onerror = function(e) {
                            console.log(e)
                        }
                    } catch (e) {
                        console.log(e);
                    }

                };

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;
                };


            },
            exportReport() {
                this.isLoading = true;
                var button = this.$refs.exportReportButton;
                var reportId = button.dataset.reportId;
                axios.get(this.cmsUrl + 'api/v1/door-checks/export/'+reportId+'.json', {headers: {'Authorization': 'Bearer '+this.$session.get('user_token')}})
                    .then(response => {
                        this.isLoading = false;
                        if (response.data.status) {
                            var ua = window.navigator.userAgent;
                            if(!!ua.match(/iPad/i) || !!ua.match(/iPhone/i)) {
                                window.location.href = response.data.pdf_url;
                            } else {
                                window.open(response.data.pdf_url, '_blank');
                            }
                        } else {
                            this.$swal('Sorry', response.data.message, 'info')
                        }
                    }).catch(error => {
                        this.isLoading = false;
                        this.$swal('Sorry', 'There was a problem. Please try again.', 'info')
                    });
            }
        }
    }
</script>